// Class: starling.text.BitmapFontType

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var BitmapFontType = function(){}

// Meta

BitmapFontType.__name__ = ["starling","text","BitmapFontType"];
BitmapFontType.prototype = {
	
};
BitmapFontType.prototype.__class__ = BitmapFontType.prototype.constructor = $hxClasses["starling.text.BitmapFontType"] = BitmapFontType;

// Init



// Statics


BitmapFontType.STANDARD = "standard"
BitmapFontType.DISTANCE_FIELD = "distanceField"
BitmapFontType.MULTI_CHANNEL_DISTANCE_FIELD = "multiChannelDistanceField"

// Export

exports.default = BitmapFontType;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/text/BitmapFontType.js
// module id = 331
// module chunks = 0